module.exports = __webpack_public_path__ + "static/img/cabinet24_1.5a697c45.gif";